import styled from 'styled-components';

import {
  ModalContent as OriginalModalContent,
  ModalHeading as OriginalModalHeading,
} from '../../modal';

export const ModalHeading = styled(OriginalModalHeading)`
  margin: 0 auto;
  ${Styles.desktop} {
    max-width: 16rem;
  }
`;

export const ModalContent = styled(OriginalModalContent)`
  .modal-inner {
    ${Styles.desktop} {
      width: calc(100% - 8.75rem);
    }
  }
`;
